// removed by extract-text-webpack-plugin
module.exports = {"layout_login":"uEAqGAzASdz6A68PDMU_l","logo":"_3LkISX8SSzqL4bp6pgg3eV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/layoutauth.css
// module id = 3048
// module chunks = 0